const getChartLabel = (entry) => String(entry?.label || entry?.name || "").trim();

const parseMultiSelectLabel = (label) => {
  if (!label) return [];

  if (Array.isArray(label)) {
    return label.map((option) => String(option).trim()).filter(Boolean);
  }

  const text = String(label).trim();

  if (!text) return [];

  if (text.startsWith("[") && text.endsWith("]")) {
    try {
      const parsed = JSON.parse(text);
      if (Array.isArray(parsed)) {
        return parsed.map((option) => String(option).trim()).filter(Boolean);
      }
    } catch (error) {
      console.error("No se pudo parsear respuesta multiple:", error);
    }
  }

  return text
    .split(";")
    .map((option) => option.trim())
    .filter(Boolean);
};

export const groupMultiSelectChartData = (data) => {
  const totalsByOption = new Map();

  (data || []).forEach((entry) => {
    const value = Number(entry?.value) || 0;
    const options = parseMultiSelectLabel(entry?.label || entry?.name);

    options.forEach((option) => {
      totalsByOption.set(option, (totalsByOption.get(option) || 0) + value);
    });
  });

  return Array.from(totalsByOption, ([label, value]) => ({ label, value })).sort(
    (a, b) => b.value - a.value
  );
};

export const normalizePieChartData = (data) =>
  (data || []).map((entry) => ({
    ...entry,
    label: getChartLabel(entry),
  }));
